import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhone, FaChevronDown, FaCar } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { CONTACT, phoneHref } from '../constants/contact';
import { SITE_NAME } from '../constants/site';
import { useQuoteModal } from '../context/QuoteModalContext';
import PhoneCTA from './PhoneCTA';
import './Navbar.css';

const homeLinks = [
  { href: '#home', label: 'Home' },
  { href: '#products', label: 'Products', chevron: true },
  { href: '#about', label: 'About' },
  { href: '#gallery', label: 'Gallery' },
  { href: '#brands', label: 'Brands' },
  { href: '#faq', label: 'FAQ' },
  { href: '#contact', label: 'Contact' },
];

const pageLinks = [
  { to: '/', label: 'Home' },
  { to: '/#products', label: 'Products' },
  { to: '/#about', label: 'About' },
  { to: '/#gallery', label: 'Gallery' },
  { to: '/#brands', label: 'Brands' },
  { to: '/#faq', label: 'FAQ' },
  { to: '/contact-us', label: 'Contact' },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const { openQuoteModal } = useQuoteModal();

  useEffect(() => { setMenuOpen(false); }, [location]);

  const handleQuoteClick = () => {
    setMenuOpen(false);
    openQuoteModal();
  };

  return (
    <header className="site-header">
      <div className="topbar">
        <div className="topbar-inner container">
          <div className="topbar-left">
            <a href={`mailto:${CONTACT.email}`} className="topbar-link">
              <MdEmail /> {CONTACT.email}
            </a>
            <span className="topbar-sep">|</span>
            <a href={phoneHref} className="topbar-link">
              <FaPhone /> {CONTACT.phone}
            </a>
          </div>
          <div className="topbar-right">
            <span className="topbar-tag">Free Shipping on Orders $100+</span>
            <span className="topbar-sep">|</span>
            <span className="topbar-tag">90-Day Warranty on All Parts</span>
          </div>
        </div>
      </div>

      <nav className={`navbar ${menuOpen ? 'menu-open' : ''}`}>
        <div className="nav-inner container">
          <Link to="/" className="nav-brand">
            <div className="brand-icon"><FaCar /></div>
            <div className="brand-text">
              <span className="brand-name">{SITE_NAME}</span>
              <span className="brand-tagline">by {CONTACT.company}</span>
            </div>
          </Link>

          <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
            {isHome
              ? homeLinks.map(({ href, label, chevron }) => (
                  <a key={href} href={href} className="nav-item" onClick={() => setMenuOpen(false)}>
                    {label}
                    {chevron && <FaChevronDown className="nav-chevron" />}
                  </a>
                ))
              : pageLinks.map(({ to, label }) => (
                  <Link key={to} to={to} className="nav-item" onClick={() => setMenuOpen(false)}>
                    {label}
                  </Link>
                ))}
            <button type="button" className="nav-quote-btn-mobile btn-orange" onClick={handleQuoteClick}>
              Get Free Quote
            </button>
          </div>

          <div className="nav-actions">
            <PhoneCTA variant="compact" className="nav-phone-cta" showNumber={false} />
            <button type="button" className="nav-quote-btn btn-orange" onClick={handleQuoteClick}>
              Get Free Quote
            </button>
          </div>

          <button
            className="nav-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
